/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from "react";
// import { _Table } from 'edviron-ui-package'
import { Table, Pagination, RowsPerPageSelect } from "../../../components/Table";
// import Table from './Table';
import { GET_SETTLEMENT_REPORTS } from "../../../Qurries";
import { useLazyQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { FaX } from "react-icons/fa6";
import { IoSearchOutline } from "react-icons/io5";
// import Modal from "../../../../components/Modal/Modal";

import { IoIosArrowDown } from "react-icons/io";
import Filters from "../Transaction/components/Filters";
import { Link, useLocation } from "react-router-dom";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import { getStartAndEndOfMonth } from "../../../utils/getStartDateAndEndDate";

export const CustomDropdownIndicator = () => {
  return (
    <div>
      <IoIosArrowDown className="text-xs w-8 text-[#1E1B59]" />
    </div>
  );
};

const Settlement = () => {
  const { get, getNumber, updateParams } = usePaymentUrlFilters();
  const location = useLocation();
  const skipUrlSyncRef = useRef(true);
  const settlementReturnPath = `${location.pathname}${location.search}`;

  const [searchInput, setSearchInput] = useState(() => get("search"));
  const [activeSearch, setActiveSearch] = useState(() => get("search"));

  const [currentPage, setCurrentPage] = useState(() => getNumber("page", 1));
  const [itemsPerPage, setItemsPerRow] = useState({
    name: getNumber("limit", 10),
  });
  // const itemsPerPage = 10; // Adjust the number of items per page as needed
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState([null]);
  const [settlementStatusFilter, setSettlementStatusFilter] = useState(() =>
    get("status"),
  );
  const [selectDays, setSelectDays] = useState(() => getNumber("selectDays", 0));
  // const [school, setSchools] = useState([{ school_id: null }]);
  const [schoolId, setSchoolId] = useState([null]);
  const [SettlementReportsData, setSettlementReportsData] = useState([]);
  const [schoolData, setSchoolData] = useState<any[]>([]);
  const [, setUnsettledAmount] = useState(null);
  const [startDate, setStartDate] = useState(() => get("start_date"));
  const [endDate, setEndDate] = useState(() => get("end_date"));
  const defaultDates = getStartAndEndOfMonth();
  // const [showCustomDateModel, setShowCustomDateModelset] = useState(false);
  const [dateDropDown, setDateDropDown] = useState(false);
  const [dateFilterType, setDateFilterType] = useState<string>(
    () => get("date_filter_type", "This Month"),
  );

  // const [checkboxFilter, setCheckboxFilter] = useState<any>({
  //   size: 0,
  //   status: 0,
  //   mode: 0,
  // });
  // const [dateFilter, setDateFilter] = useState<{
  //   type: string;
  //   startDate: string;
  //   endDate: string;
  // }>({
  //   type: "",
  //   startDate: new Date(0).toLocaleString("en-US", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //   }),
  //   endDate: new Date().toLocaleString("en-US", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //   }),
  // });
  // const [, setSelectStatus] = useState<any>({
  //   Settled: false,
  //   Pending: false,
  // });

  const [selectedTime, setSelectedTime] = useState<string>("Date");

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // const handleClearTimeRange = () => {
  //   setDateRange([
  //     {
  //       startDate: new Date(),
  //       endDate: new Date(""),
  //       key: "selection",
  //     },
  //   ]);
  //   setEndDate("");
  // };
  const [
    getSettlementReports,
    { loading: settlementLoading },
  ] = useLazyQuery(GET_SETTLEMENT_REPORTS, {
    fetchPolicy: "network-only",
    variables: {
      startDate: defaultDates.startDate,
      endDate: defaultDates.endDate,
    },
    onCompleted: (data) => {
      const result = data?.getMerchantSettlementReports;
      if (!result) return;

      setSchoolData(result.data ?? []);

      setTotalPages(
        Math.ceil(result.total / result.limit)
      );
    },
  });
  // let updatedSettlementData: [];
  // const [
  //   getSettlementReports,
  //   {
  //     data: settlementReportData,
  //     loading: settlementLoading,
  //     refetch: settlementRefetch,
  //   },
  // ] = useLazyQuery(GET_SETTLEMENT_REPORTS, {
  //   onCompleted: (data) => {
  //     setSettlementReportsData(data.getMerchantSettlementReports);
  //     setSchoolData(data.getMerchantSettlementReports);
  //     if (data.getSettlementReports.length > 0) {
  //       const totalPrice = data.getSettlementReports
  //         .map((adj: any) => adj.adjustment)
  //         .reduce((acc: any, adjustment: any) => acc + adjustment, 0);

  //       setUnsettledAmount(totalPrice);
  //     }
  //   },
  // });

  useEffect(() => {
    getSettlementReports({
      variables: {
        filters: {
          search: activeSearch || null,
          status: settlementStatusFilter === "Settled" ? ["Settled", "SUCCESS"] : null,
          // dateFilterType: dateFilterType || null,
          startDate: selectDays > 0 ? startDate : defaultDates.startDate,
          endDate: selectDays > 0 ? endDate : defaultDates.endDate,
          page: currentPage,
          limit: itemsPerPage.name,
        },
      },
    });
  }, [
    activeSearch,
    settlementStatusFilter,
    startDate,
    endDate,
    dateFilterType,
    currentPage,
    itemsPerPage,
    getSettlementReports,
  ]);

  useEffect(() => {
    skipUrlSyncRef.current = false;
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    updateParams({
      page: currentPage > 1 ? currentPage : null,
      limit: itemsPerPage.name !== 10 ? itemsPerPage.name : null,
      search: activeSearch || null,
      status: settlementStatusFilter || null,
      start_date: startDate
        ? new Date(startDate).toLocaleDateString("en-CA", {
          timeZone: "Asia/Kolkata",
        })
        : null,
      end_date: endDate
        ? new Date(endDate).toLocaleDateString("en-CA", {
          timeZone: "Asia/Kolkata",
        })
        : null,
      date_filter_type:
        dateFilterType !== "This Month" ? dateFilterType : null,
      selectDays: selectDays > 0 ? selectDays : null
    });
  }, [
    activeSearch,
    settlementStatusFilter,
    startDate,
    endDate,
    dateFilterType,
    currentPage,
    itemsPerPage.name,
    updateParams,
    selectDays
  ]);

  // const isDateInRange = (
  //   dateToCheck: any,
  //   rangeStartDate: any,
  //   rangeEndDate: any
  // ) => {
  //   // Implement your date range comparison logic here
  //   return dateToCheck >= rangeStartDate && dateToCheck <= rangeEndDate;
  // };

  const handlePageChange = (page: any) => setCurrentPage(page);

  const handleFilterChange = (selectedFilter: any) => {
    setSettlementStatusFilter(selectedFilter.value);
    const val = selectedFilter.value;
    setFilters((prev) => (prev.includes(val) ? prev : [...prev, val]));
    setCurrentPage(1);
  };

  const removeFilter = (index: number) => {
    setFilters((prev) => prev.filter((_, i) => i !== index));
    setCurrentPage(1);
  };

  const handleApplyClick = () => {
    if (startDate && endDate) {
      const diff =
        new Date(endDate).getTime() - new Date(startDate).getTime();
      const days = Math.ceil(diff / (24 * 60 * 60 * 1000));
      setSelectDays(days);
      setDateDropDown(false);
      setCurrentPage(1);
    } else {
      toast.error("Both start and end dates are required");
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    const unsettledAmountSum = SettlementReportsData.map(
      (adj: any) => adj.adjustment
    ).reduce((acc: any, adjustment: any) => acc + adjustment, 0);

    setUnsettledAmount(unsettledAmountSum);
  }, [SettlementReportsData]);

  // Helper function to filter by date range
  const filterByDateRange = (
    data: any,
    currentDate: Date,
    selectDays: number
  ) => {
    const settlementDate = new Date(data.settlementDate);

    const timeDifference: number =
      currentDate.getTime() - settlementDate.getTime();

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference < 0) {
      return false;
    }
    return daysDifference <= selectDays;
  };

  const filterBySchoolName = (data: any, schoolId: any[]) => {
    return schoolId.length === 1 || schoolId.includes(data.schoolName);
  };
  // const filterByStatus = (data: any, filter: any[]) => {
  //   return filter.length === 1 || filter.includes(data.status);
  // };

  // const dateOptions = [
  //   {
  //     name: "Today",
  //     value: 1,
  //   },
  //   {
  //     name: "Last 7 Days",
  //     value: 7,
  //   },
  //   {
  //     name: "Last 1 Month",
  //     value: 30,
  //   },
  //   {
  //     name: "Last 1 Year",
  //     value: 365,
  //   },
  // ];

  // const filter2 = [
  //   {
  //     name: "Settled",
  //   },
  //   {
  //     name: "Pending",
  //   },
  // ];

  // const daysOptions = dateOptions.map((filter) => {
  //   return { label: filter.name, value: filter.value };
  // });

  // const statusFilter: any = [
  //   { value: "Settled", label: "Settled" },
  //   { value: "Pending", label: "Pending" },
  // ];
  // const stats = filter2.map((status) => {
  //   return { label: status.name, value: status.name };
  // });


  // const handleFilterChange = (selectedFilter: any) => {
  //   // Check if the selected filter is already in the state
  //   setSettlementStatusFilter(selectedFilter.value);

  //   let check: any = selectedFilter.value;
  //   let checkFilter: any = filters;

  //   if (!checkFilter.includes(check)) {
  //     setFilters([...filters, check]);
  //   }
  // };

  const dataContainsQuery = (data: any, query: string) => {
    return Object.values(data).some((value: any) => {
      if (value === null || value === undefined) {
        return false;
      }
      const stringValue = String(value);
      return stringValue.toLowerCase().includes(query.toLowerCase());
    });
  };

  // const totalPages = Math.ceil(schoolData.length / itemsPerPage);
  // const pageNumbers = Array.from(
  //   { length: totalPages },
  //   (_, index) => index + 1
  // );

  // const paginatedData = schoolData.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  // const handleSchoolFilterChange = (selectedFilter: any) => {
  //   // Check if the selected filter is already in the state
  //   let check: any = selectedFilter?.value;
  //   let checkFilter: any = schoolId;
  //   // setSettlementStatusFilter(selectedFilter.value)
  //   if (!checkFilter.includes(check)) {
  //     setSchoolId([...schoolId, check]);
  //   }
  // };
  // const removeFilter = (index: any) => {
  //   // Create a new array without the filter at the specified index
  //   const updatedFilters = filters.filter((_, i) => i !== index);
  //   setFilters(updatedFilters);
  // };

  const removeSchoolFilter = (index: any) => {
    const updateSchoolFilter = schoolId.filter((_, i) => i !== index);
    setSchoolId(updateSchoolFilter);
  };
  // const handleApplyClick = () => {
  //   if (startDate && endDate) {
  //     const startDateObj = new Date(startDate);
  //     const endDateObj = new Date(endDate);

  //     // Calculate the difference in milliseconds
  //     const timeDifference = endDateObj.getTime() - startDateObj.getTime();

  //     // Convert milliseconds to days (1 day = 24 * 60 * 60 * 1000 milliseconds)
  //     const daysDifference = Math.ceil(timeDifference / (24 * 60 * 60 * 1000));

  //     setStartDate(startDate);
  //     setEndDate(endDate);
  //     setShowCustomDateModelset(!showCustomDateModel);
  //     setSelectDays(daysDifference);
  //     setDateDropDown(!dateDropDown);
  //   } else {
  //     // Handle case where either startDate or endDate is null
  //     toast.error("Both start and end dates are required");
  //     console.error("Both start and end dates are required.");
  //   }
  // };

  // const { mode, size, status, ...allOtherFilter } = checkboxFilter;
  // const handleDeleteStatusFilters = (status: string) => {
  //   setCheckboxFilter((pre: any) => {
  //     delete pre[status?.toLowerCase()];
  //     return { ...pre, size: pre.size - 1, status: pre.status - 1 };
  //   });
  //   status = status.charAt(0).toUpperCase() + status.substring(1);
  //   setSelectStatus((pre: any) => {
  //     return { ...pre, [status]: false };
  //   });
  // };

  return (
    <div className="overflow-hidden">
      <h2 className="text-[#1B163B] text-[28px] font-[600]">Settlements</h2>
      <div className="w-full -ml-2 flex justify-between items-end">
        <div className="text-[#229635] font-[400] flex ">
          {/* <span className="text-[48px] flex items-center">
            <LiaRupeeSignSolid />{" "}
            {unsettledAmount !== null ? (
              <span>{unsettledAmount}</span>
            ) : (
              <span>0</span>
            )}
          </span>
          <span className="text-[20px] text-[#717171] flex items-center ml-2">
            {` (unsettled amount)`}
          </span> */}
        </div>
        <div className="">
          <div className="text-[14px] font-[400] text-right m-0">
            settlement cycle
          </div>
          <div className="text-[20px] font-[600] text-[#6687FF] m-0 mt-0">
            1 working day
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col overflow-x-auto mt-1">
        {schoolData ? (
          <Table
            perPage={false}
            exportBtn={true}
            loading={settlementLoading}
            heading={"History"}
            srNo={false}
            pagination={false}
            copyContent={[8]}
            filter={[activeSearch]}
            isCustomFilter={true}
            searchBox={
              <div className="flex flex-col w-full">
                <div className="flex w-full justify-between items-center">
                  <div className="bg-[#EEF1F6] py-3 items-center flex px-6 max-w-md w-full rounded-lg">
                    <input
                      type="text"
                      className="text-xs bg-transparent focus:outline-none w-full placeholder:font-normal"
                      onFocus={(e) => (e.target.style.borderColor = "transparent")}
                      placeholder="Search..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setActiveSearch(searchInput.trim());
                          setCurrentPage(1);
                        }
                      }}
                    />
                    {searchInput && (
                      <FaX
                        className="cursor-pointer text-gray-400 h-3 ml-2"
                        onClick={() => {
                          setSearchInput("");
                          setActiveSearch("");
                          setCurrentPage(1);
                        }}
                      />
                    )}
                    <IoSearchOutline
                      className="cursor-pointer text-edvion_black text-opacity-50 text-md ml-3"
                      onClick={() => {
                        setActiveSearch(searchInput.trim());
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                  <div className="flex items-center ">
                    {/* Date Filter */}
                    <Filters
                      selectedTime={selectedTime}
                      setSelectedTime={setSelectedTime}
                      dateRange={dateRange}
                      setDateRange={setDateRange}
                      transaction={false}
                      setSettlementStatusFilter={setSettlementStatusFilter}
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      startDate={startDate}
                      endDate={endDate}
                      setSelectDays={setSelectDays}
                      setDateDropDown={setDateDropDown}
                      dateDropDown={dateDropDown}
                      setDateFilterType={setDateFilterType}
                      dateFilterType={dateFilterType}
                    />
                    {/* Status Filter */}
                    {/* <div className="">
                      <Select
                        className="font-normal px-2 rounded-lg "
                        options={statusFilter}
                        value={null}
                        // onChange={handleStatusChange}
                        // onChange={handleFilterChange}
                        onChange={(selectedOption: any) => {
                          setSettlementStatusFilter(selectedOption.value);
                          // setSchoolData(settlements)
                        }}
                        // onChange={setSettlementStatusFilter}
                        placeholder={
                          <div className="text-[#1E1B59] text-xs">Status</div>
                        }
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            backgroundColor: "##F6F8FA",
                            border: "1px solid #6687FF",
                            width: "180px",
                          }),
                          input: (provided: any) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            "::placeholder": {
                              backgroundColor: "#YourDesiredColor",
                              opacity: 1,
                            },
                          }),
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="flex ">
                  {filters.map(
                    (filter, index) =>
                      filter !== null && (
                        <div
                          className="bg-[#6687FFCC] text-sm m-2 rounded-lg min-w-max h-10 px-2 flex items-center gap-x-2"
                          key={index}
                        >
                          <span className="text-white">{filter}</span>
                          <span>
                            <FaX
                              className="text-white cursor-pointer"
                              onClick={() => removeFilter(index)}
                            />
                          </span>
                        </div>
                      )
                  )}
                  {schoolId.map(
                    (school, index) =>
                      school !== null && (
                        <div
                          className="bg-[#6687FFCC] text-[16px] m-2 rounded-[8px] w-[131px] h-[40px] flex items-center justify-around"
                          style={{ maxWidth: "8em" }}
                          key={index}
                        >
                          <span className="text-white truncate pl-2">
                            {school}
                          </span>
                          <span>
                            <FaX
                              className="text-white cursor-pointer h-3"
                              onClick={() => removeSchoolFilter(index)}
                            />
                          </span>
                        </div>
                      )
                  )}
                  {selectDays !== 0 && (
                    <div className="bg-[#6687FFCC] text-sm m-2 rounded-lg min-w-max h-10 px-2 flex items-center gap-x-2">
                      <span className="text-white">{dateFilterType}</span>
                      <span>
                        <FaX
                          className="text-white cursor-pointer h-3"
                          onClick={() => {
                            setDateFilterType("");
                            setStartDate("");
                            setDateRange([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
                            setEndDate("");
                            setSelectDays(0);
                            setSelectedTime("Date");
                          }}
                        />
                      </span>
                    </div>
                  )}
                  {settlementStatusFilter !== "" && (
                    <div className="bg-[#6687FFCC] text-sm m-2 rounded-lg min-w-max h-10 px-2 flex items-center gap-x-2">
                      <span className="text-white">
                        {settlementStatusFilter}
                      </span>
                      <span>
                        <FaX
                          className="text-white cursor-pointer h-3"
                          onClick={() => setSettlementStatusFilter("")}
                        />
                      </span>
                    </div>
                  )}
                </div>
                <div>
                  <RowsPerPageSelect
                    setItemsPerRow={(e: any) => {
                      setCurrentPage(1);
                      setItemsPerRow(e);
                    }}
                    itemsPerRow={itemsPerPage}
                    className="justify-start"
                  />
                </div>
              </div>
            }
            footer={
              <div className="flex justify-center items-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            }
            data={[
              [
                "Sr. No.",
                "Settlement Amount",
                "Adjustment",
                "Payment Amount",
                "From",
                "Till",
                "Status",
                "UTR No",
                "Settlement Date",
              ],

              ...schoolData?.map((data: any, index: any) => [
                (currentPage - 1) * itemsPerPage.name + 1 + index,
                <Link
                  to="/payments/settlements-transaction"
                  state={{
                    utrno: data.utrNumber,
                    settlementDate: data.settlementDate,
                    from: settlementReturnPath,
                  }}
                >
                  <div key={data.utrNumber} className=" truncate">
                    ₹{data.settlementAmount}
                  </div>
                </Link>,
                <div key={data.utrNumber} className=" truncate">
                  {data.adjustment}
                </div>,
                <div key={data.utrNumber} className=" truncate">
                  ₹{data.netSettlementAmount}
                </div>,
                <div key={data.utrNumber} className=" truncate">
                  {new Date(data.fromDate).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </div>,
                <div key={data.utrNumber} className=" truncate">
                  {/* {data.Till} */}
                  {new Date(data.tillDate).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </div>,
                <div
                  className={
                    " truncate " +
                    (data.status.toLowerCase() === "settled" ||
                      data.status.toLowerCase() === "success" ||
                      data.status.toLowerCase() === "processed"
                      ? "text-[#04B521]"
                      : "")
                  }
                >
                  {data.status.toLowerCase() === "settled" ||
                    data.status.toLowerCase() === "success" ||
                    data.status.toLowerCase() === "processed"
                    ? "Settled"
                    : data.status}
                </div>,
                <div
                  key={data.utrNumber}
                  className=" truncate overflow-hidden"
                  style={{ maxWidth: "5em" }}
                  title={data.utrNumber}
                >
                  {data.utrNumber}
                </div>,
                <div key={data.utrNumber} className="truncate">
                  {/* {data.SettlementDate} */}
                  {new Date(data.settlementDate).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  })}
                </div>,
              ]),
            ]}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Settlement;
